module.exports = __webpack_public_path__ + "static/media/lahore-north-dark.38fe7544.svg";